import {
    ConversationHeader,
    MoreIconVerticalImage,
    MoreIconVerticalImageHolder
} from "../../containers/Conversation/common";
import {ReactComponent as MoreIconVertical} from "../../../assets/icons/moreIconVertical.svg";
import React, {useEffect, useRef, useState} from "react";
import styled from 'styled-components'
import {ReactComponent as AllFiles} from 'assets/icons/allfiles.svg';
import {ReactComponent as RestartConversation} from 'assets/icons/restartConversation.svg';

const Popover = styled.div`
  position: absolute;
  float: bottom;
  right: ${p => p.shouldShowRestartConversation ? '2px':'7px'};
  top: ${p => p.shouldShowRestartConversation ? '70px':'78px'};
  background: linear-gradient(180deg, #F9FAFD 0%, #FFFFFF 100%);
  box-shadow: 0px 10px 20px rgba(53, 59, 71, 0.0709135);
  border-radius: 10px;
  &::before{
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    top: -28px;
    right: 13px;
    border: 10px solid transparent;
    border-bottom: 18px solid #F9FAFD;
  }
}
`;

const EntirePopover = styled.div`
    display: ${p => p.disabled ? 'none':''};
`

const Options = styled.div`
    padding: 7px 16px;
`
const Option = styled.div`
    cursor: pointer;
  display: flex;
  padding: 9px 0;
  &:not(&:last-child){
    border-bottom: 1px solid #EDF0F7;
  }
`

const OptionText = styled.div`
  font-size: 12px;
  line-height: 14px;
    color: ${p => p.color ? p.color : "#2F3C4E"}
  margin-left: 7px;
`

const Icon = styled.svg`
`

let useOutsideAlerter = (ref, setIsOpen) => {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsOpen(false);
            }
        }

        document.addEventListener("mouseup", handleClickOutside);
        return () => {
            document.removeEventListener("mouseup", handleClickOutside);
        };
    }, [ref]);
}


const MoreOptions = props => {
    const {
        Language,
        setDisplayAllFiles,
        triggerBot,
        shouldShowRestartConversation,
        userSettingColor,
        showInputBox,
        disableFileSharing
    } = props;
    const [isOpen, setIsOpen] = React.useState(false);
    const containerRef = useRef(null);
    const [fillAllFiles, setFillAllFiles] = useState("#2F3C4E");
    const [fillRestartConversation, setFillRestartConversation] = useState("#2F3C4E");
    useOutsideAlerter(containerRef, setIsOpen);

    const handleClick = (event) => {
        setIsOpen(!isOpen);
    };

    const fill = shouldShowRestartConversation ? "#353B47" : (userSettingColor.headerTextColor || "#FFFFFF");
    const opacity = shouldShowRestartConversation ? 0.3 : 1;

    let handleFillChangeColor = (element, enter) => {
        switch (element){
            case 1:
                if(enter)setFillAllFiles("#F44238")
                else setFillAllFiles("#2F3C4E");
                break;
            case 2:
                if(enter)setFillRestartConversation("#F44238");
                else setFillRestartConversation("#2F3C4E");
                break;
            default:
                setFillAllFiles("#2F3C4E");
                setFillRestartConversation("#2F3C4E");
        }
    }

    const renderOptions = () => {
        return (
            <>
                {!disableFileSharing && <Option onClick={() => {setIsOpen(false);handleFillChangeColor(-1, false);setDisplayAllFiles(true);}} onMouseEnter={()=>{handleFillChangeColor(1, true)}} onMouseLeave={() => {handleFillChangeColor(1, false)}}>
                    <AllFiles fill={fillAllFiles}></AllFiles>
                    <OptionText color={fillAllFiles}>{Language.AllFiles}</OptionText>
                </Option>}
                {shouldShowRestartConversation && showInputBox && <Option onClick={() => {setIsOpen(false);handleFillChangeColor(-1, false); triggerBot()}} onMouseEnter={()=>{handleFillChangeColor(2, true)}} onMouseLeave={() => {handleFillChangeColor(2, false)}}>
                    <RestartConversation fill={fillRestartConversation}></RestartConversation>
                    <OptionText color={fillRestartConversation}>{Language.RestartConversation}</OptionText>
                </Option>}
            </>
        )
    }


    return(
        <EntirePopover ref={containerRef} disabled={(!shouldShowRestartConversation||!showInputBox) && !!disableFileSharing}>
            <MoreIconVerticalImageHolder onClick={handleClick}>
                <MoreIconVertical fill={fill} opacity={opacity}/>
            </MoreIconVerticalImageHolder>
            {isOpen &&
            <Popover shouldShowRestartConversation={shouldShowRestartConversation}>
                <Options>
                    {renderOptions()}
                </Options>
            </Popover>
            }
        </EntirePopover>

    );
}

export default MoreOptions;


